import CarouselContainer from './CarouselContainer'
import CarouselContainerItem from './CarouselContainerItem'
import CarouselContainerImage from './CarouselContainerImage'
import CarouselContainerButton from './CarouselContainerButton'
import CarouselContainerControl from './CarouselContainerControl'
import CarouselContainerMultiple from './CarouselContainerMultiple'

// helper function
import register from '../../util/functions/register'

const Carousel = {
  CarouselContainer,
  CarouselContainerItem,
  CarouselContainerImage,
  CarouselContainerButton,
  CarouselContainerControl,
  CarouselContainerMultiple,
}

export default { install: Vue => register(Vue, Carousel) }



// WEBPACK FOOTER //
// ./src/js/components/carousel/index.js